module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('group', {
    attrs: {
      "title": "指定授权经办人",
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "is-type": "china-name",
      "placeholder": "请输入姓名",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersName),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersName", $$v)
      },
      expression: "data.managersName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersDocumentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "text-align": "right",
      "placeholder": "请输入证件类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.managersDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersDocumentsType", $$v)
      },
      expression: "data.managersDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersIdCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "is-type": _vm.isIdCard,
      "placeholder": "请输入证件号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    on: {
      "on-change": _vm.idcardChange
    },
    model: {
      value: (_vm.data.managersIdCardNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersIdCardNo", $$v)
      },
      expression: "data.managersIdCardNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "managersDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效日期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.managersDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersDocumentsValidity", $$v)
      },
      expression: "data.managersDocumentsValidity"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    ref: "managersSex",
    style: ({
      color: _vm.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.managersSex),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersSex", $$v)
      },
      expression: "data.managersSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.managersAge),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersAge", $$v)
      },
      expression: "data.managersAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersPosition),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersPosition", $$v)
      },
      expression: "data.managersPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersLanline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "is-type": _vm.isPhone,
      "placeholder": "格式：区号+座机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersLanline),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersLanline", $$v)
      },
      expression: "data.managersLanline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "is-type": "china-mobile",
      "placeholder": "请输入手机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersMobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersMobile", $$v)
      },
      expression: "data.managersMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "is-type": "email",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersEmail),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersEmail", $$v)
      },
      expression: "data.managersEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "tel",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersZip),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersZip", $$v)
      },
      expression: "data.managersZip"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersAddress", $$v)
      },
      expression: "data.managersAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "relationshipWithOrg",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "与该机构关系",
      "placeholder": "请输入与该机构关系",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.relationshipWithOrg),
      callback: function($$v) {
        _vm.$set(_vm.data, "relationshipWithOrg", $$v)
      },
      expression: "data.relationshipWithOrg"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_agency_auth
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53792caa"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Agency/Three.vue
// module id = 1054
// module chunks = 1